import React from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../ReduxToolkit/Store';
// import HeaderLeft from './HeaderLeft';
import HeaderRight from './HeaderRight';
import { Button, Col } from 'reactstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Plus } from 'react-feather';
import HorizontalLogo from './HeaderLeft/HorizontalLogo';

export default function Header() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { sideBarToggle } = useSelector((state: RootState) => state.layout);

    return (
        <header className={`page-header row ${sideBarToggle ? 'close_icon' : ''}`}>
            <HorizontalLogo />
            {/* <Col xs="auto" className=" d-flex align-items-center">
                {pathname === '/home' ? (
                    <Button color='primary' onClick={() => navigate('/create')}>Create Company <Plus size={18} /></Button>
                ) : pathname === '/create' ? (
                    <h3>Setup Company</h3>
                ) : pathname?.includes('/upload-data') ? (
                    <h3>Update Company Data</h3>
                ) : null}
            </Col> */}
            <Col className="page-main-header">
                {/* <HeaderLeft /> */}
                <HeaderRight />
            </Col>
        </header>
    )
}